import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { getDataAttributes } from '../../../util/getDataAttributes/getDataAttributes.js';
import { Checkbox } from '../../Control/Checkbox/Checkbox.js';
import { RadioButton } from '../../Control/RadioButton/RadioButton.js';
import { ListItem } from '../../List/ListItem.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DropdownListItemV1 = function DropdownListItemV1(props) {
  var item = props.item,
    formName = props.formName,
    type = props.type,
    onChange = props.onChange,
    onKeyDown = props.onKeyDown,
    enableEnterKeyActions = props.enableEnterKeyActions;
  var selectedState = item.selected ? 'selected' : 'unselected';
  var state = item.disabled ? 'disabled' : 'enabled';
  var onControlChange = function onControlChange(value) {
    return onChange(_objectSpread(_objectSpread({}, item), {}, {
      selected: !value
    }));
  };
  var _getDataAttributes = getDataAttributes(props),
    dataAttributes = _getDataAttributes.dataAttributes;
  var handleKeyDown = function handleKeyDown(event) {
    if (onKeyDown) {
      onKeyDown(event);
    }
    if (enableEnterKeyActions && (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar')) {
      event.preventDefault();
      onControlChange(type === 'single' ? false : selectedState === 'selected');
    }
  };
  var control = type === 'single' ?
  /*#__PURE__*/
  // eslint-disable-next-line @agoda/agoda-a11y/no-incorrect-props -- Disabled the rule to allow onKeyDown to be passed to the component to fix a11y issue, this component will be deprecated in the future
  React.createElement(RadioButton, _extends({
    role: "option",
    "aria-selected": item.selected,
    name: formName,
    state: state,
    selection: selectedState,
    onInputChange: onControlChange,
    onKeyDown: handleKeyDown
  }, dataAttributes)) :
  /*#__PURE__*/
  // eslint-disable-next-line @agoda/agoda-a11y/no-incorrect-props -- Disabled the rule to allow onKeyDown to be passed to the component to fix a11y issue, this component will be deprecated in the future
  React.createElement(Checkbox, _extends({
    name: formName,
    state: state,
    selection: selectedState,
    onInputChange: onControlChange,
    onKeyDown: handleKeyDown
  }, dataAttributes));
  var asset = item.leadingIcon && {
    id: item.leadingIcon
  } || item.leadingAsset;
  return /*#__PURE__*/React.createElement(ListItem, {
    key: item.key,
    title: item.label,
    disabled: item.disabled,
    control: control,
    asset: asset,
    p: "16",
    cursor: "pointer"
  });
};

export { DropdownListItemV1 };
//# sourceMappingURL=DropdownListItemV1.js.map
